// Баннер «Поставить на экран Домой» (M10.2) и честная заглушка пушей (M10.6).
//
// Правило одно: предложить один раз. Закрыли крестиком — не возвращаемся
// никогда, флаг лежит в localStorage. Баннер, вылезающий каждый заход, человек
// перестаёт читать на третий раз и начинает промахиваться мимо него в таб-бар.
//
// Флаг СОЗНАТЕЛЬНО не привязан к профилю (в отличие от очереди правок):
// приложение ставится на телефон целиком, а не отдельно под каждый профиль.

import { useEffect, useState } from 'react'
import { load, save } from '../lib/persist'
import { isIos, isStandalone, promptInstall, watchInstallPrompt } from '../lib/pwa'
import { PUSH_READY, QUIET_HOURS } from './offline'
import './install.css'

const DISMISSED_KEY = 'mobile.install'

export default function InstallBanner() {
  // Уже установлено — предлагать нечего. Считаем один раз при монтировании:
  // display-mode внутри жизни экрана не меняется.
  const [hidden, setHidden] = useState(
    () => isStandalone() || load<boolean>(DISMISSED_KEY, false),
  )
  const [canInstall, setCanInstall] = useState(false)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (hidden) return
    return watchInstallPrompt(setCanInstall)
  }, [hidden])

  // iOS не присылает beforeinstallprompt вообще: там установка только руками
  // через «Поделиться». Показывать нечего, кроме подсказки, — но показать её
  // надо, иначе на iPhone баннера не будет никогда.
  const ios = isIos()
  if (hidden || (!canInstall && !ios)) return null

  const dismiss = () => {
    save(DISMISSED_KEY, true)
    setHidden(true)
  }

  const install = async () => {
    setBusy(true)
    try {
      await promptInstall()
    } finally {
      setBusy(false)
      // Диалог одноразовый: событие больше не придёт, и повторно предлагать
      // нечем — независимо от того, согласились или нет.
      dismiss()
    }
  }

  return (
    <div className="ab-install" role="note">
      <div className="ab-install__text">
        <div className="ab-install__title">Поставить на экран «Домой»</div>
        <div className="ab-install__hint">
          {ios && !canInstall
            ? 'Поделиться → «На экран „Домой“»: панель откроется без адресной строки'
            : 'Панель откроется как приложение — без адресной строки и быстрее'}
        </div>
      </div>
      {canInstall ? (
        <button
          type="button"
          className="ab-install__go"
          onClick={() => void install()}
          disabled={busy}
        >
          Поставить
        </button>
      ) : null}
      <button
        type="button"
        className="ab-install__close"
        onClick={dismiss}
        aria-label="Больше не предлагать"
      >
        ✕
      </button>
    </div>
  )
}

/**
 * Пуш-уведомления (M10.6) — строка для экрана настроек/базы.
 *
 * На сервере web-push нет ни в каком виде, поэтому это ТЕКСТ С БЕЙДЖЕМ, а не
 * переключатель: кнопка, которая ничего не включает, хуже её отсутствия.
 * Что именно нужно на сервере — в комментарии к `PUSH_READY` в offline.ts.
 */
export function PushSoon() {
  if (PUSH_READY) return null
  const quiet = `${String(QUIET_HOURS.from).padStart(2, '0')}:00–${String(QUIET_HOURS.to).padStart(2, '0')}:00`
  return (
    <div className="ab-push" role="note">
      <div className="ab-push__row">
        <span className="ab-push__title">Уведомления о готовности задачи</span>
        <span className="ab-push__badge">скоро</span>
      </div>
      <div className="ab-push__hint">
        Придут, когда агент закончит фоновую задачу. Тихие часы {quiet} — не будим.
      </div>
    </div>
  )
}
